import React from "react";

import {
  RideGrid,
  RideButton,
  RideGlArrowBack,
} from "@rimac-seguros/ride-system-components";
import { useSelector } from "react-redux";

import { getFormatDecimalMount, getFormatMount } from "@/utils/Utils";
import history from "@/utils/history";
import useBreakpoint from "@/hooks/useBreakpoint";

import "./styles.scss";
import { VE_ROUTES_ENDORSEMENT } from "@/utils/consts";
import helpers from "@/utils/helpers";
import { getProductOptions, getScreenName } from "@/utils/product";

export const FooterAction = ({
  loading,
  disabled,
  showContentPrice = true,
  loadingAnimation,
  contentAdditional,
  textButton = "Continuar",
  auxTextFrequency = "",
  className = "",
  classNameContent = "",
  classNameButton = "",
  onHandleClick,
}) => {
  const isDesktop = useBreakpoint("large-min");
  const isVE = helpers.validateVidaEndosable();
  const { digitalDataProductName } = getProductOptions();
  const { nameFrequency, typeOfFinancing, planSelected, maxAmountQuote } = useSelector(
    (state) => state.plans
  );
  const { sumAssured } = planSelected || {};
  const descMoney = sumAssured?.descripcion;
  const { pathname } = window.location;
  const isEndorsementRoute = VE_ROUTES_ENDORSEMENT.some((route) =>
    pathname.includes(route.path)
  );
  const isCreditMaxAmount = Number(sumAssured?.value) > maxAmountQuote;

  const goBack = () => {
    if (isVE) {
      const screenName = getScreenName();

      helpers.setActionTag({
        group: digitalDataProductName,
        category: screenName,
        action: "click",
        label: "Atras",
      });
    }
    history.goBack();
  };

  return (
    <div
      className={`
      fixed 
      bottom-0 
      left-0
      z-10 
      w-full 
      overflow-hidden 
      pb-ride-gl-spacing-2xlarge 
      bg-ride-sys-color-background-default 
      shadow-ride-gl-shadow-moderate
      ${classNameContent}
    `}
    >
      {isEndorsementRoute && contentAdditional}
      <RideGrid>
        {!isEndorsementRoute && contentAdditional}
        <div
          className={`relative flex justify-between items-center col-span-full lg:justify-end lg:gap-ride-gl-spacing-4xlarge pt-ride-gl-spacing-2xlarge ${className}`}
        >
          {!!contentAdditional && !isEndorsementRoute && (
            <div className="footer-action-divider" />
          )}
          <RideButton
            text="Atrás"
            variant="text-secondary"
            size="medium"
            glyph={<RideGlArrowBack />}
            glyphPosition="left"
            className="absolute left-0 hidden lg:flex"
            onClick={goBack}
          />
          {showContentPrice && (
            isEndorsementRoute && isCreditMaxAmount ? (
              <div></div>
            ) : (
              <div>
                <span
                  className={`ride-sys-text-label-small-regular mb-ride-gl-spacing-medium ${
                    loadingAnimation && isEndorsementRoute ? "blink-loading" : ""
                  }`}
                >
                  Monto a pagar
                </span>
                <div
                  className={`md-special:flex-row md-special:items-baseline ${
                    loadingAnimation ? "blink-loading" : ""
                  } ${!isEndorsementRoute ? "flex flex-col" : ""}`}
                >
                  <span className="ride-sys-text-label-2xlarge-default">
                    {descMoney}
                    {getFormatMount(
                      isEndorsementRoute
                        ? typeOfFinancing?.valor || 0
                        : typeOfFinancing?.pagoMensual || 0,
                      true
                    )}
                    .
                    <span
                      className={`${
                        isEndorsementRoute
                          ? "ride-sys-text-title-medium-default"
                          : "ride-sys-text-title-large-default"
                      }`}
                    >
                      {getFormatDecimalMount(
                        isEndorsementRoute
                          ? typeOfFinancing?.valor || 0
                          : typeOfFinancing?.pagoMensual || 0,
                        true
                      )}
                    </span>
                  </span>
                  <span
                    className={`${
                      isEndorsementRoute
                        ? "ride-sys-text-paragraph-small-default lg:ride-sys-text-paragraph-large-regular"
                        : "ride-sys-text-label-small-regular"
                    }`}
                  >
                    /
                    {isEndorsementRoute
                      ? (nameFrequency || auxTextFrequency)?.toLowerCase()
                      : nameFrequency || auxTextFrequency}
                  </span>
                </div>
              </div>
            )
          )}
          <RideButton
            text={textButton}
            fullWidth={isEndorsementRoute && isCreditMaxAmount && !isDesktop}
            size="x-large"
            loading={loading}
            disabled={disabled}
            className={classNameButton}
            onClick={() => onHandleClick?.()}
          />
        </div>
      </RideGrid>
    </div>
  );
};
